module.exports = __webpack_public_path__ + "img/APPPrestamos.592358ff.png";